import React, { useState } from "react";

const MintPage = () => {
	const [value, setValue] = useState(0);
	return (
		<section id="mint">
			<div className="container">
				<h1 className="heading">
					MINT YOUR <br /> <span className="focus">META WOMAN</span>
				</h1>
				<p className="sub-text">
					TOTAL MINTED: <span className="focus">3380 / 5000</span>
				</p>

				<p className="eth-text">0.05 ETH + GAS FEE</p>
				<p className="max-text">MAX 20 HUNGRY HAMSTER PER TRANSACTION</p>
				<div className="counter">
					<div className="col">
						<span onClick={() => setValue(value - 1)} className="c-btn">
							<svg
								width="76"
								height="73"
								viewBox="0 0 76 73"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<rect width="76" height="73" fill="#151510" />
								<path
									d="M23.4167 34H52.4167C53.0576 34 53.6723 34.2546 54.1255 34.7078C54.5787 35.161 54.8333 35.7757 54.8333 36.4167C54.8333 37.0576 54.5787 37.6723 54.1255 38.1255C53.6723 38.5787 53.0576 38.8333 52.4167 38.8333H23.4167C22.7757 38.8333 22.161 38.5787 21.7078 38.1255C21.2546 37.6723 21 37.0576 21 36.4167C21 35.7757 21.2546 35.161 21.7078 34.7078C22.161 34.2546 22.7757 34 23.4167 34V34Z"
									fill="white"
								/>
							</svg>
						</span>
						<div className="count">{value}</div>
						<span onClick={() => setValue(value + 1)} className="c-btn">
							<svg
								width="76"
								height="73"
								viewBox="0 0 76 73"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<rect width="76" height="73" fill="#151510" />
								<path
									d="M40.3333 33.5V21.4167C40.3333 20.7757 40.0787 20.161 39.6255 19.7078C39.1723 19.2546 38.5576 19 37.9167 19C37.2757 19 36.661 19.2546 36.2078 19.7078C35.7546 20.161 35.5 20.7757 35.5 21.4167V33.5H23.4167C22.7757 33.5 22.161 33.7546 21.7078 34.2078C21.2546 34.661 21 35.2757 21 35.9167C21 36.5576 21.2546 37.1723 21.7078 37.6255C22.161 38.0787 22.7757 38.3333 23.4167 38.3333H35.5V50.4167C35.5 51.0576 35.7546 51.6723 36.2078 52.1255C36.661 52.5787 37.2757 52.8333 37.9167 52.8333C38.5576 52.8333 39.1723 52.5787 39.6255 52.1255C40.0787 51.6723 40.3333 51.0576 40.3333 50.4167V38.3333H52.4167C53.0576 38.3333 53.6723 38.0787 54.1255 37.6255C54.5787 37.1723 54.8333 36.5576 54.8333 35.9167C54.8333 35.2757 54.5787 34.661 54.1255 34.2078C53.6723 33.7546 53.0576 33.5 52.4167 33.5H40.3333Z"
									fill="white"
								/>
							</svg>
						</span>
					</div>
					<div className="col">
						{[5, 15, 20].map((val) => (
							<div onClick={() => setValue(val)} className="box">
								{val}
							</div>
						))}
					</div>
				</div>

				<button className="connect-btn">connect wallet</button>
			</div>
			<img
				className="mint-img-1"
				src="/assets/images/landing/mint-img-1.png"
				alt=""
			/>
			<img
				className="mint-img-2"
				src="/assets/images/landing/mint-img-2.png"
				alt=""
			/>
		</section>
	);
};

export default MintPage;
